import { ButtonWithDemoExitConfirmation } from '../DemoExitConfirmation/ButtonWithDemoExitConfirmation';
import { MenuPickerSubmenuItem } from '../Menu';
import styled, { css } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledSpan = styled.span.withConfig({
  displayName: "PortalPickerSubmenuItem__StyledSpan",
  componentId: "sc-1qqi73c-0"
})(({
  theme
}) => css(["color:", " !important;"], theme.color['text-primary-default']));
const PortalPickerSubmenuItem = ({
  account
}) => {
  const href = encodeURI(`${account.appDomain}/home-beta?portalId=${account.id}`);
  return /*#__PURE__*/_jsx(ButtonWithDemoExitConfirmation, {
    component: MenuPickerSubmenuItem,
    link: href,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [`${account.name}:`, /*#__PURE__*/_jsx(StyledSpan, {
        children: account.id
      })]
    })
  });
};
export default PortalPickerSubmenuItem;